import { IMoySkladSyncStatusResponse } from 'models/seller'
import { IMAGES_URL } from 'shared/constants/urls'

export const SYNC_STATUS_POLL_INTERVAL = 5000

export const IN_PROGRESS_STATUS = 'В процессе'

export interface ISyncStatusMeta {
  isVisible: boolean
  isProcessing: boolean
  totalCount: number
  notPublishedCount: number
  disabledCount: number
  reportUrl: string
}

export const getSyncReportUrl = (reportUrl?: string | null): string => {
  if (!reportUrl) {
    return ''
  }

  if (/^https?:\/\//i.test(reportUrl)) {
    return reportUrl
  }

  const normalizedBase = IMAGES_URL.endsWith('/') ? IMAGES_URL : `${IMAGES_URL}/`
  const normalizedPath = reportUrl.startsWith('/') ? reportUrl.slice(1) : reportUrl

  return `${normalizedBase}${normalizedPath}`
}

export const getSyncStatusMeta = (
  syncStatus: IMoySkladSyncStatusResponse | null
): ISyncStatusMeta => {
  const isProcessing = syncStatus?.status === IN_PROGRESS_STATUS

  return {
    isVisible: Boolean(syncStatus?.status),
    isProcessing,
    totalCount: syncStatus?.processed ?? syncStatus?.totalCount ?? 0,
    notPublishedCount:
      syncStatus?.draftCount ?? syncStatus?.notPublishedCount ?? 0,
    disabledCount: syncStatus?.disabledCount ?? 0,
    reportUrl: getSyncReportUrl(syncStatus?.reportUrl)
  }
}
